import React, { ReactNode } from 'react';
import { createPortal } from 'react-dom';

import { usePortal } from '@/hooks/usePortal';

interface PortalPropsTypes {
  id: string;
  children: ReactNode;
  childId?: string;
}

const Portal: React.FC<PortalPropsTypes> = ({ id, children, childId = '' }) => {
  const target = usePortal(id, childId);
  return target ? createPortal(children, target) : null;
};

export default Portal;
